import FadeInAnimation from './FadeInAnimation';

export default FadeInAnimation;
